<template>
  <div v-if="isEmpty(notification.sender)" class="pp_missing" :class="getBackground(notification)" style="margin-top: 0;">
    <i class="fa t-xlr" :class="getIcon(notification)" style="line-height: inherit;" />
  </div>
  <avatar-missing v-else-if="!notification.sender.avatar" :name="getFullName(notification.sender)" :maxChars="3"/>
  <avatar v-else-if="notification.sender.avatar" :name="getFullName(notification.sender)" :avatar="notification.sender.avatar" :editable="false" />
</template>

<script>
/**
 * This is the picture shown inside a notification. (used by Flash and Notification.vue)
 * Depending on the notification, it can either be a user profile's avatar, or an icon.
 */
import AvatarMissing from '@/components/shared/AvatarMissing'
import Avatar from '@/components/shared/Avatar'

const ICONS = {
  info: 'fa-info-circle',
  warning: 'fa-exclamation-triangle',
  download: 'fa-download',
  error: 'fa-times-circle',
  success: 'fa-check',
  wait: 'fa-hourglass-start',
  mail: 'fa-envelope '
}

const BG = {
  info: '',
  warning: 'bg-yellow',
  download: 'bg-green',
  error: 'bg-red',
  success: 'bg-green',
  wait: 'bg-blue',
  mail: 'bg-blue'
}

export default {
  name: 'notificationImage',
  props: {
    notification: Object
  },
  components: {
    AvatarMissing,
    Avatar
  },
  methods: {
    getIcon (notification) {
      return ICONS[notification.variant] || ICONS['info']
    },
    getBackground (notification) {
      return BG[notification.variant] || BG['info']
    }
  }
}
</script>
